import styled from '@emotion/styled';
import { CloseIcon } from 'src/domains/layouts/shared/assets/icons/CloseIcon';
import { ChatIcon } from 'src/domains/layouts/shared/assets/icons/ChatIcon';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

export const HeaderWrapper = withConfig(theme => styled('header', { label: 'HeaderWrapper' })`
    display: flex;
    flex: 0 0 56px;
    align-items: center;
    position: relative;
    background: ${theme.star.sidebar.bgColor};
    color: ${theme.star.sidebar.txtColor};
    font-size: ${theme.star.fontSize.regular};
    line-height: 1.3;
`);

interface TitleWrapperPropsType {
    variant: DefaultComponentVariantType | null;
    hasIcon: boolean;
    isSmallerVersion?: boolean;
}

export const TitleWrapper = withConfig(theme => styled('h2', { label: 'TitleWrapper' })<TitleWrapperPropsType>`
    color: ${theme.star.sidebar.txtColor};
    font-size: ${({ isSmallerVersion }): string => isSmallerVersion === true ? theme.star.fontSize.xRegular : theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    margin: ${({ hasIcon }): string => hasIcon === true ? '0' : '0 0 0 16px'};
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`);

export const HeaderCloseIcon = styled(CloseIcon, { label: 'HeaderCloseIcon' })`
    cursor: pointer;
    fill: currentcolor;
    margin-left: auto;
    padding: 14px;
    width: 48px;
`;

export const ArrowBackIcon = styled(ChevronIcon, { label: 'ArrowBackIcon' })`
    cursor: pointer;
    fill: currentcolor;
    padding: 12px 0;
    width: 48px;
    height: 44px;
`;

export const TraderChatIcon = styled(ChatIcon, { label: 'TraderChatIcon' })`
    fill: currentcolor;
    padding: 12px;
    width: 48px;
`;
